import { cn } from "@repo/cn";

import type { JSX } from "react";

interface ProgressBarProps {
  progress: number;
  /** Use "light" when the bar is placed over a white/light background */
  variant?: "dark" | "light";
  /** Color family used on the "light" variant */
  color?: "primary" | "secondary";
}

export const ProgressBar = ({
  progress,
  variant = "dark",
  color = "primary",
}: ProgressBarProps): JSX.Element => {
  const styles = {
    progress: {
      width: `${progress * 100}%`,
    },
  };

  const lightTrackClass = color === "secondary" ? "bg-neutral-100" : "bg-primary-100";
  const lightFillClass = color === "secondary" ? "bg-secondary-400" : "bg-primary-400";

  const trackClass = variant === "light" ? lightTrackClass : "bg-white/25";
  const fillClass = variant === "light" ? lightFillClass : "bg-white";

  return (
    <div
      data-testid="full-progress-bar"
      className={cn(`my-1 rounded-sm w-full h-2`, trackClass)}
    >
      <div
        data-testid="actual-progress-bar"
        style={styles.progress}
        className={cn(
          `transition-all duration-200`,
          fillClass,
          `h-full rounded-sm max-w-full`,
        )}
      />
    </div>
  );
};
